// @ts-expect-error - TS7016 - Could not find a declaration file for module '@spaced-out/ui-lib/lib/button/button'. '/Users/diwaker/SpacedOut/ui-server/node_modules/@spaced-out/ui-lib/lib/button/button.js' implicitly has an 'any' type.
import type {Props as ButtonProps} from '@spaced-out/ui-lib/lib/button/button';

import * as React from 'react';
import {Link} from 'src/rerouter';

import classify from 'src/utils/classify';

import css from './button.css';

// TODO (kyle): there has to be a good way to share more code with
// Button.
export function LinkButton({
  type = 'default',
  size = 'small',
  round,
  styleDisabled,
  icon,
  className,
  children,
  ...props
}: ButtonProps & {
  className?: string;
  children?: React.ReactNode;
}) {
  return (
    <Link
      {...props}
      className={classify(className, css.buttonText, css[type], css[size], {
        [css.buttonIcon]: icon,
        [css.buttonEnabled]: true,
        [css.buttonDisabled]: styleDisabled,
        [css.buttonRound]: round,
      })}
    >
      {icon && <div className={css.icon}>{icon}</div>}
      <span className={css.children}>{children}</span>
    </Link>
  );
}
